/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SalespersonBudgetRestService, SalespersonBudgetType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { sbBudgetFromDto, sbBudgetToSaveDto, SbListItem } from './sb-list.model';

@Injectable()
export class SalespersonBudgetListBusinessService implements InitViewService {
  constructor(private salespersonBudgetRest: SalespersonBudgetRestService,
              private dictionaryService: DictionaryService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      types: this.dictionaryService.getByEnum(SalespersonBudgetType),
      items: this.salespersonBudgetRest.get().pipe(map$(sbBudgetFromDto)),
    };
  }

  update(budget: SbListItem[]): Observable<SbListItem[]> {
    return this.salespersonBudgetRest.update(sbBudgetToSaveDto(budget)).pipe(map$(sbBudgetFromDto));
  }
}
